import React, { useEffect, useMemo, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiConfig';

const FALLBACK_OPTIONS = [
  { value: 'cash', label: 'Cash' },
  { value: 'loan', label: 'Loan' }
];

function PaymentTypeDropdown({ onChangeDropdown, required, showLabel = true, isDisabled, selectedValue }) {
  const [options, setOptions] = useState(FALLBACK_OPTIONS);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    const fetchPaymentTypes = async () => {
      try {
        const response = await axios.get(`${getApiBaseUrl()}/master/values/bykey/paymentType`);
        if (response.status === 200 && response.data?.success) {
          const mapped = (response.data.data || []).map((item) => ({
            value: item.ValueKey,
            label: item.DisplayName,
            masterValueId: item.MasterValueId
          }));
          if (mapped.length) {
            setOptions(mapped);
            return;
          }
        }
        setOptions(FALLBACK_OPTIONS);
      } catch (error) {
        console.error('Failed to load payment types', error);
        setOptions(FALLBACK_OPTIONS);
      }
    };

    fetchPaymentTypes();
  }, []);

  useEffect(() => {
    if (selectedValue === undefined || selectedValue === null) {
      setSelectedOption(null);
      return;
    }
    const nextValue = options.find((item) => item.value === selectedValue) || null;
    setSelectedOption(nextValue);
  }, [selectedValue, options]);

  const placeholder = useMemo(() => (isDisabled ? 'Payment type unavailable' : 'Select payment type'), [isDisabled]);

  const handleChange = (option, actionMeta) => {
    setSelectedOption(option);
    if (onChangeDropdown) {
      onChangeDropdown(option, actionMeta);
    }
  };

  return (
    <div>
      {showLabel && (
        <label className="form-label">
          Payment Type {required ? <span style={{ color: 'red' }}>*</span> : null}
        </label>
      )}
      <Select
        name="PaymentType"
        value={selectedOption}
        isClearable
        isDisabled={isDisabled}
        options={options}
        onChange={handleChange}
        placeholder={placeholder}
        menuPlacement="auto"
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  );
}

export default PaymentTypeDropdown;
